<ng-template #basicInfo>
    @if (nameDateGroup) {
        <form [formGroup]="nameDateGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'controls.advEffWizard.basicInfoHeader' | transloco }}</label>
                </div>
            </div>
            <div class="row centered-row">
                @if (standingData) {
                    <div class="col-12 pb-5 text-start" [hidden]="isSummary">
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.selectOriginLabel' | transloco }}</label>
                            <ng-select
                                data-uiid="wizard-testplan-origin-select"
                                [(ngModel)]="effectivenessOrigin"
                                [ngModelOptions]="{ standalone: true }"
                                bindValue="ID"
                                bindLabel="Name"
                                [clearable]="false"
                                (change)="originChanged()"
                                [items]="[
                                    { ID: 1, Name: 'New Test Plan' },
                                    { ID: 2, Name: 'Copy from existing Test Plan' },
                                    { ID: 3, Name: 'Copy from catalogue' },
                                ]"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            @switch (effectivenessOrigin) {
                                @case (originTypes.existing) {
                                    <label>{{ 'controls.advEffWizard.selectExistingLabel' | transloco }}</label>
                                    <ng-select
                                        data-uiid="wizard-testplan-to-copy-select"
                                        [(ngModel)]="originExistingID"
                                        [ngModelOptions]="{ standalone: true }"
                                        bindValue="ID"
                                        bindLabel="Name"
                                        [items]="existingTestPlans | async"
                                        [loading]="!existingTestPlans && !originLoading"
                                        [clearable]="false"
                                        (change)="loadExistingEffectiveness()"
                                    >
                                    </ng-select>
                                }
                                @case (originTypes.catalogue) {
                                    <label>{{ 'controls.advEffWizard.selectCatalogueLabel' | transloco }}</label>
                                    <ng-select
                                        data-uiid="wizard-catalogue-to-copy-select"
                                        [(ngModel)]="originCatalogueID"
                                        [ngModelOptions]="{ standalone: true }"
                                        bindValue="ID"
                                        bindLabel="Name"
                                        [items]="catalogues | async"
                                        [loading]="!catalogues && !originLoading"
                                        [clearable]="false"
                                        (change)="loadCatalogue()"
                                    >
                                    </ng-select>
                                }
                            }
                        </div>
                    </div>
                    <div class="col left-block">
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.nameTestPlanLabel' | transloco }}</label>
                            <cerrix-textfield
                                dataUiid="wizard-testplan-name-textfield"
                                [errorLabel]="'controls.advEffWizard.nameTestPlanErrorLabel' | transloco"
                                formControlName="name"
                            ></cerrix-textfield>
                        </div>
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.testPeriodLabel' | transloco }}</label>
                            <ng-select
                                data-uiid="wizard-test-period-select"
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="testPeriod"
                                [items]="standingData.TestPeriodData"
                                [loading]="!standingData.TestPeriodData"
                            >
                            </ng-select>
                        </div>
                    </div>
                    <div class="col right-block">
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.startDateLabel' | transloco }}</label>
                            <date-input
                                data-uiid="wizard-start-date-dateinput"
                                formControlName="startDate"
                            ></date-input>
                            @if (nameDateGroup.controls.startDate.errors) {
                                <div class="red" data-uiid="wizard-start-date-error-div">
                                    @if (nameDateGroup.controls.startDate.errors.periodDates) {
                                        <p>
                                            {{
                                                nameDateGroup.controls.startDate.errors.periodDates
                                            }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.endDateLabel' | transloco }}</label>
                            <date-input
                                data-uiid="wizard-end-date-dateinput"
                                formControlName="endDate"
                            ></date-input>
                            @if (nameDateGroup.controls.endDate.errors) {
                                <div class="red" data-uiid="wizard-end-date-error-div">
                                    @if (
                                        nameDateGroup.controls.endDate.errors.startDateAfterEndDate
                                    ) {
                                        <p>
                                            {{
                                                nameDateGroup.controls.endDate.errors
                                                    .startDateAfterEndDate
                                            }}
                                        </p>
                                    }
                                    @if (nameDateGroup.controls.endDate.errors.periodDates) {
                                        <p>
                                            {{ nameDateGroup.controls.endDate.errors.periodDates }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </form>
    }
</ng-template>

<ng-template #sampleGeneration>
    @if (sampleGenerationGroup) {
        <form [formGroup]="sampleGenerationGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'controls.advEffWizard.sampleGenerationHeader' | transloco }}</label>
                </div>
            </div>
            <div class="row centered-row">
                @if (standingData) {
                    <div class="col">
                        <div class="form-group-inline">
                            <cerrix-checkbox
                                dataUiid="wizard-use-controlexecution-checkbox"
                                [label]="'controls.advEffWizard.useControlExecutionLabel' | transloco"
                                formControlName="useControlExecution"
                            ></cerrix-checkbox>
                            <i
                                class="fas fa-info-circle ms-2"
                                [title]="'controls.advEffWizard.useControlExecutionInfo' | transloco"
                            ></i>
                        </div>
                        <div class="form-group">
                            <label
                                >{{ 'controls.advEffWizard.sampleGenerationMethodLabel' | transloco }}
                                <i
                                    class="fas fa-info-circle ms-2"
                                    [matTooltip]="'controls.advEffWizard.sampleGenerationMethodTooltip' | transloco"
                                ></i
                            ></label>
                            <ng-select
                                data-uiid="wizard-sample-generation-method-select"
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="sampleGenerationMethod"
                                [items]="standingData.SampleGenMethData"
                                [loading]="!standingData.SampleGenMethData"
                                (change)="setDisabledControls()"
                                [clearable]="false"
                            >
                            </ng-select>
                            @if (sampleGenerationGroup.controls.sampleGenerationMethod.errors) {
                                <div
                                    class="red txt-align-left"
                                    data-uiid="wizard-sample-method-error-div"
                                >
                                    @if (
                                        sampleGenerationGroup.controls.sampleGenerationMethod.errors
                                            .SampleMethod
                                    ) {
                                        <p>
                                            {{
                                                sampleGenerationGroup.controls
                                                    .sampleGenerationMethod.errors.SampleMethod
                                            }}
                                        </p>
                                    }
                                </div>
                            }
                        </div>
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.reasonManualSampleLabel' | transloco }}</label>
                            <cerrix-textarea
                                dataUiid="wizard-reason-manual-sample-generation-textarea"
                                [errorLabel]="'controls.advEffWizard.reasonManualSampleErrorLabel' | transloco"
                                formControlName="reasonManualSampleGeneration"
                            ></cerrix-textarea>
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </form>
    }
</ng-template>

<ng-template #personsInvolvedDueDates>
    @if (personsInvolvedGroup) {
        <form [formGroup]="personsInvolvedGroup">
            <div class="row header-row">
                <div class="col left-block">
                    <label>{{ 'controls.advEffWizard.personsInvolvedHeader' | transloco }}</label>
                </div>
                <div class="col right-block">
                    <label>{{ 'controls.advEffWizard.dueDatesHeader' | transloco }}</label>
                </div>
            </div>
            <div>
                @if (standingData) {
                    <div class="row centered-row">
                        <div class="col left-block">
                            <div class="form-group">
                                @if (showSourceDocumentUploader) {
                                    <label>{{ 'controls.advEffWizard.sourceDocUploaderLabel' | transloco }}</label>
                                    <i
                                        class="fas fa-info-circle ms-2"
                                        [title]="'controls.advEffWizard.sourceDocUploaderInfo' | transloco"
                                    ></i>
                                    <ng-select
                                        data-uiid="wizard-source-document-uploader-select"
                                        bindValue="ID"
                                        bindLabel="Name"
                                        formControlName="sourceDocumentUploaders"
                                        [items]="standingData.SourceDocumentUploaderData"
                                        [loading]="!standingData.SourceDocumentUploaderData"
                                        [multiple]="true"
                                        [closeOnSelect]="false"
                                    >
                                    </ng-select>
                                } @else {
                                    <label>{{ 'controls.advEffWizard.noSourceDocRequired' | transloco }}</label>
                                }
                            </div>
                        </div>
                        <div class="col right-block">
                            @if (showSourceDocumentUploader) {
                                <div class="form-group">
                                    <label>{{ 'controls.advEffWizard.sourceDocDueDateLabel' | transloco }}</label>
                                    <date-input
                                        data-uiid="wizard-source-document-uploader-due-date-dateinput"
                                        formControlName="sourceDocumentDueDate"
                                    ></date-input>
                                    @if (
                                        personsInvolvedGroup.controls.sourceDocumentDueDate.errors
                                    ) {
                                        <div
                                            data-uiid="wizard-source-document-uploader-due-date-error-div"
                                            class="red"
                                        >
                                            @if (
                                                personsInvolvedGroup.controls.sourceDocumentDueDate
                                                    .errors.DueDate
                                            ) {
                                                <p>
                                                    {{
                                                        personsInvolvedGroup.controls
                                                            .sourceDocumentDueDate.errors.DueDate
                                                    }}
                                                </p>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                    <div class="row centered-row">
                        <div class="col left-block">
                            <div class="form-group">
                                <label>{{ 'controls.advEffWizard.evidenceUploaderLabel' | transloco }}</label>
                                <ng-select
                                    data-uiid="wizard-evidence-uploader-select"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    formControlName="evidenceUploaders"
                                    [items]="standingData.EvidenceUploaderData"
                                    [loading]="!standingData.EvidenceUploaderData"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    (change)="setSourceDocumentUploaderUsers()"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="col right-block">
                            <div class="form-group">
                                <label>{{ 'controls.advEffWizard.evidenceDueDateLabel' | transloco }}</label>
                                <date-input
                                    data-uiid="wizard-evidence-uploader-due-date-dateinput"
                                    formControlName="evidenceDueDate"
                                ></date-input>
                                @if (personsInvolvedGroup.controls.evidenceDueDate.errors) {
                                    <div
                                        class="red"
                                        data-uiid="wizard-evidence-uploader-due-date-error-div"
                                    >
                                        @if (
                                            personsInvolvedGroup.controls.evidenceDueDate.errors
                                                .DueDate
                                        ) {
                                            <p>
                                                {{
                                                    personsInvolvedGroup.controls.evidenceDueDate
                                                        .errors.DueDate
                                                }}
                                            </p>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    <div class="row centered-row">
                        <div class="col left-block">
                            <div class="form-group">
                                <label>{{ 'controls.advEffWizard.testerLabel' | transloco }}</label>
                                <ng-select
                                    data-uiid="wizard-tester-select"
                                    bindValue="ID"
                                    bindLabel="Name"
                                    formControlName="testers"
                                    [items]="standingData.TesterData"
                                    [loading]="!standingData.TesterData"
                                    [multiple]="true"
                                    [closeOnSelect]="false"
                                    (change)="setSourceDocumentUploaderUsers()"
                                >
                                </ng-select>
                            </div>
                        </div>
                        <div class="col right-block">
                            <div class="form-group">
                                <label>{{ 'controls.advEffWizard.testerDueDateLabel' | transloco }}</label>
                                <date-input
                                    data-uiid="wizard-tester-due-date-dateinput"
                                    formControlName="testerDueDate"
                                ></date-input>
                                @if (personsInvolvedGroup.controls.testerDueDate.errors) {
                                    <div class="red" data-uiid="wizard-tester-due-date-error-div">
                                        @if (
                                            personsInvolvedGroup.controls.testerDueDate.errors
                                                .DueDate
                                        ) {
                                            <p>
                                                {{
                                                    personsInvolvedGroup.controls.testerDueDate
                                                        .errors.DueDate
                                                }}
                                            </p>
                                        }
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                    @if (!reviewerRequiredApplicationSetting) {
                        <div class="row centered-row">
                            <div class="form-group">
                                <label>{{ 'controls.advEffWizard.reviewStepLabel' | transloco }}
                                    <i
                                        class="fas fa-info-circle ms-2"
                                        [matTooltip]="'controls.advEffWizard.reviewStepTooltip' | transloco"
                                    ></i
                                ></label>
                                <mat-slide-toggle
                                    data-uiid="wizard-review-step-toggle"
                                    name="reviewEnabled"
                                    formControlName="reviewEnabled"
                                    size="small"
                                    color="primary"
                                    class="ms-5"
                                >
                                </mat-slide-toggle>
                            </div>
                        </div>
                    }
                    <div class="row centered-row">
                        <div class="col left-block">
                            @if (showReviewers) {
                                <div class="form-group">
                                    <label>{{ 'controls.advEffWizard.reviewerLabel' | transloco }}</label>
                                    <ng-select
                                        data-uiid="wizard-reviewers-select"
                                        bindValue="ID"
                                        bindLabel="Name"
                                        formControlName="reviewers"
                                        [items]="standingData.ReviewerData"
                                        [loading]="!standingData.ReviewerData"
                                        [multiple]="true"
                                        [closeOnSelect]="false"
                                        (change)="setSourceDocumentUploaderUsers()"
                                    >
                                    </ng-select>
                                </div>
                            }
                        </div>
                        <div class="col right-block">
                            @if (showReviewers) {
                                <div class="form-group">
                                    <label>{{ 'controls.advEffWizard.reviewerDueDateLabel' | transloco }}</label>
                                    <date-input
                                        data-uiid="wizard-reviewers-due-date-dateinput"
                                        formControlName="reviewerDueDate"
                                    ></date-input>
                                    @if (personsInvolvedGroup.controls.reviewerDueDate.errors) {
                                        <div
                                            class="red"
                                            data-uiid="wizard-reviewers-due-date-error-div"
                                        >
                                            @if (
                                                personsInvolvedGroup.controls.reviewerDueDate.errors
                                                    .DueDate
                                            ) {
                                                <p>
                                                    {{
                                                        personsInvolvedGroup.controls
                                                            .reviewerDueDate.errors.DueDate
                                                    }}
                                                </p>
                                            }
                                        </div>
                                    }
                                </div>
                            }
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </form>
    }
</ng-template>

<ng-template #testInformation>
    @if (basicTestInfoGroup) {
        <form [formGroup]="basicTestInfoGroup">
            <div class="row header-row">
                <div class="col">
                    <label>{{ 'controls.advEffWizard.testInformationHeader' | transloco }}</label>
                </div>
            </div>
            <div class="row centered-row">
                @if (standingData) {
                    <div class="col left-block">                        
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.sourceDocUploadInstructionsLabel' | transloco }}</label>
                            <i
                                class="fas fa-info-circle ms-2"
                                [title]="'controls.advEffWizard.sourceDocUploadInstructionsInfo' | transloco"
                            ></i>
                            <cerrix-textarea
                                dataUiid="wizard-source-document-upload-instructions-textarea"
                                [errorLabel]="'controls.advEffWizard.sourceDocUploadInstructionsLabel' | transloco"
                                formControlName="sourceDocumentUploadInstructions"
                            ></cerrix-textarea>
                        </div>
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.evidenceUploadInstructionsLabel' | transloco }}</label>
                            <i
                                class="fas fa-info-circle ms-2"
                                [title]="'controls.advEffWizard.evidenceUploadInstructionsInfo' | transloco"
                            ></i>
                            <cerrix-textarea
                                dataUiid="wizard-evidence-upload-instructions-textarea"
                                [errorLabel]="'controls.advEffWizard.evidenceUploadInstructionsLabel' | transloco"
                                formControlName="evidenceUploadInstructions"
                            ></cerrix-textarea>
                        </div>                        
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.testInstructionsLabel' | transloco }}</label>
                            <cerrix-textarea
                                dataUiid="wizard-test-instructions-textarea"
                                [errorLabel]="'controls.advEffWizard.testInstructionsLabel' | transloco"
                                formControlName="testInstructions"
                            ></cerrix-textarea>
                        </div>
                    </div>
                    <div class="col right-block">
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.linkedStandardLabel' | transloco }}</label>
                            <ng-select
                                data-uiid="wizard-linked-standard-select"
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="linkedStandard"
                                [items]="standingData.LinkedStandardData"
                                [loading]="!standingData.LinkedStandardData"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.qualityAspectsLabel' | transloco }}</label>
                            <ng-select
                                data-uiid="wizard-quality-aspects-select"
                                bindValue="ID"
                                bindLabel="Name"
                                formControlName="qualityAspects"
                                [items]="standingData.QualityAspectData"
                                [loading]="!standingData.QualityAspectData"
                                [multiple]="true"
                                [closeOnSelect]="false"
                            >
                            </ng-select>
                        </div>
                        <div class="form-group">
                            <label>{{ 'controls.advEffWizard.testNormLabel' | transloco }}</label>
                            <cerrix-textarea
                                dataUiid="wizard-test-norm-textarea"
                                [errorLabel]="'controls.advEffWizard.testNormLabel' | transloco"
                                formControlName="testNorm"
                            ></cerrix-textarea>
                        </div>
                    </div>
                } @else {
                    <div class="fancy-loader submodule"></div>
                }
            </div>
        </form>
    }
</ng-template>

<ng-template #testSteps>
    <div class="row header-row">
        <div class="col">
            <label>{{ 'controls.advEffWizard.testStepsHeader' | transloco }}</label>
        </div>
    </div>

    @if (testStepConfig) {
        <generic-list-manager [config]="testStepConfig" #testStepManager></generic-list-manager>
    }
</ng-template>

<ng-template #summary>
    @if (model && !effectivenessGuid) {
        <div class="row header-row">
            <div class="col">
                <label>{{ 'controls.advEffWizard.summaryHeader' | transloco }}</label>
            </div>
        </div>
        <div class="row centered-row">
            <div class="col">
                <cerrix-checkbox
                    dataUiid="wizard-save-as-catalogue-checkbox"
                    [label]="'controls.advEffWizard.saveAsCatalogueLabel' | transloco"
                    [(ngModel)]="model.storeAsCatalogue"
                ></cerrix-checkbox>
                @if (model.storeAsCatalogue) {
                    <div class="form-group">
                        <label>{{ 'controls.advEffWizard.catalogueNameLabel' | transloco }}</label>
                        <cerrix-textfield
                            dataUiid="wizard-save-as-catalogue-catalogue-name-textfield"
                            [errorLabel]="'controls.advEffWizard.catalogueNameErrorLabel' | transloco"
                            [(ngModel)]="model.storeAsCatalogueName"
                        ></cerrix-textfield>
                    </div>
                }
            </div>
        </div>
    }
</ng-template>

@if (wizardConfig) {
    <cerrix-wizard
        [config]="wizardConfig"
        [templates]="[
            basicInfo,
            sampleGeneration,
            personsInvolvedDueDates,
            testInformation,
            testSteps,
        ]"
        [summaryTemplate]="summary"
        #wizard
    >
    </cerrix-wizard>
}
